import http from "../../http";
import { Funcionario } from "./entities/Funcionario";

const actions = {
  criar: async (state, { unidade, nome, email, matricula }) => {
    try {
      await http.post("apiv2/auth/users", {
        vendor: unidade,
        name: nome,
        email: email,
        sap: matricula,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  editar: async (
    state,
    { funcionarioId, nome, email, centroCusto, funcao, cargo }
  ) => {
    try {
      await http.put(`apiv2/auth/users/${funcionarioId}`, {
        name: nome,
        email: email,
        cost_center_id: centroCusto,
        function_id: funcao,
        cargo: cargo,
      });
      console.log(nome);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  listar: async (state, { unidadeId, paginacao }) => {
    try {
      let params = {};
      if (unidadeId) {
        params.vendor_id = unidadeId;
      }
      if (paginacao) {
        params.per_page = paginacao.rowsPerPage;
        params.page = paginacao.page;
      }

      let resposta = await http.get("apiv2/auth/users", { params });
      resposta = resposta.data;

      let listaFuncionarios = [];
      resposta.results.data.forEach((funcionarioDTO) => {
        listaFuncionarios.push(
          new Funcionario({
            id: funcionarioDTO.id,
            nome: funcionarioDTO.name,
            email: funcionarioDTO.email,
            sap: funcionarioDTO.sap,
            funcao: funcionarioDTO.function,
          })
        );
      });

      paginacao.page = resposta.results.current_page;
      paginacao.rowsPerPage = resposta.results.per_page;
      paginacao.rowsNumber = resposta.results.total;

      return {
        listaFuncionarios,
        paginacao,
      };
    } catch (error) {
      switch (error.message) {
        case "Network Error":
          console.log("Token expirado");
          break;
        default:
          console.error(error);
          throw error;
      }
    }
  },

  consultar: async (state, { funcionarioId }) => {
    let resposta = await http.get(`apiv2/auth/users/${funcionarioId}`);
    resposta = resposta.data;

    let funcionario = new Funcionario({
      id: resposta.model.id,
      nome: resposta.model.name,
      email: resposta.model.email,
      sap: resposta.model.sap,
      codIntegracao: resposta.model.codigo_integracao,
      funcao: resposta.model.function,
      dataAdmissao: resposta.model.admission_date,
      cargo: resposta.model.cargo,
      centroCustoEPI: resposta.model.cost_center.name,
    });

    return {
      funcionario,
    };
  },
};

export const funcionario = {
  namespaced: true,
  actions,
};
